import { JOB, SORT_ORDERS } from '@/search/constants'

export const DEFAULT_HAS_MULTIPLE_PAGES = false
export const DEFAULT_LOADING = false
export const DEFAULT_LIST = []
export const DEFAULT_NEXT_LOADING = false
export const DEFAULT_NEXT_PARAMS = null
export const DEFAULT_ORDER_OPTIONS = SORT_ORDERS
export const DEFAULT_QUALITY_RESULT_SIZE = null
export const DEFAULT_SEARCH_PARAMS = { type: JOB }
export const DEFAULT_TOTAL_SIZE = null
export const DEFAULT_RESULT_PARAMS = {}

export default {
  hasMultiplePages: DEFAULT_HAS_MULTIPLE_PAGES,
  highQualitySize: DEFAULT_QUALITY_RESULT_SIZE,
  list: DEFAULT_LIST,
  loading: DEFAULT_LOADING,
  lowQualitySize: DEFAULT_QUALITY_RESULT_SIZE,
  nextLoading: DEFAULT_NEXT_LOADING,
  nextParams: DEFAULT_NEXT_PARAMS,
  orderOptions: DEFAULT_ORDER_OPTIONS,
  searchParams: DEFAULT_SEARCH_PARAMS,
  totalSize: DEFAULT_TOTAL_SIZE,
  resultParams: DEFAULT_RESULT_PARAMS
}
